// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__7IZgu","choiceBoxes":"toolbarselects_choiceBoxes__3tSPa","simpleField":"toolbarselects_simpleField__2B41C"};